var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncrediblyFlexibleImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 213,
    viewBox: "0 0 309 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_264)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M73.6705 11.2316C97.9093 4.23169 126.589 0.282107 157.197 0.528956C161.231 0.56422 165.229 0.670012 169.193 0.846333C196.067 3.29719 205.621 31.579 189.415 43.9567C181.984 49.6343 173.014 49.5814 169.193 49.5461C165.229 49.3698 161.231 49.264 157.197 49.2287C126.589 48.9819 97.927 52.9314 73.6882 59.9314C49.2195 65.8734 47.7687 41.0827 56.3319 25.9191C59.2157 20.8235 64.5589 14.1233 73.6882 11.2316H73.6705Z",
    fill: "#172F78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8065 61.3596C60.3311 61.3596 56.651 58.5913 54.6164 55.9113C48.7248 48.1708 50.8656 34.5588 55.8725 25.6899C58.7918 20.5061 64.2411 13.7177 73.5297 10.7556C98.6354 3.47352 127.598 -0.264479 157.198 1.5609e-06C161.178 0.0352657 165.23 0.141058 169.211 0.317379C182.728 1.55162 193.574 9.75053 196.9 21.2114C199.483 30.1332 196.74 39.0021 189.734 44.3623C182.162 50.1456 173.086 50.0927 169.175 50.0574C165.212 49.8811 161.178 49.7753 157.18 49.7401C127.616 49.5108 98.8123 53.1959 73.8128 60.4251C71.1589 61.0598 68.8412 61.3419 66.7888 61.3419L66.8065 61.3596ZM73.8305 11.743C64.8604 14.5993 59.6057 21.1761 56.7749 26.1836C51.9271 34.7704 49.8217 47.8711 55.4302 55.2765C59.0218 60.0019 65.285 61.4301 73.5474 59.4377C98.6177 52.1909 127.598 48.4705 157.198 48.7174C161.214 48.7527 165.248 48.8584 169.211 49.0348C172.979 49.0524 181.808 49.1229 189.097 43.5512C195.75 38.4555 198.368 30.0274 195.891 21.5288C192.689 10.4734 182.18 2.57428 169.122 1.39293C165.177 1.21661 161.143 1.11082 157.18 1.07556C127.633 0.828709 98.83 4.53144 73.8128 11.7606L73.8305 11.743Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.128 249C149.961 249 146.776 248.312 144.37 246.919L85.4542 213.013C83.0126 211.602 81.668 209.698 81.668 207.653C81.668 205.607 83.0126 203.703 85.4542 202.293L144.07 168.333C148.9 165.547 156.755 165.547 161.603 168.333L220.519 202.24C222.96 203.65 224.305 205.555 224.305 207.6C224.305 209.645 222.96 211.549 220.519 212.96L161.904 246.919C159.48 248.312 156.313 249 153.146 249H153.128ZM152.81 167.328C149.837 167.328 146.865 167.981 144.6 169.285L85.9849 203.245C83.8972 204.444 82.7472 206.013 82.7472 207.653C82.7472 209.293 83.8972 210.862 85.9849 212.061L144.901 245.967C149.43 248.577 156.808 248.577 161.337 245.967L219.953 212.008C222.04 210.809 223.191 209.24 223.191 207.6C223.191 205.96 222.04 204.391 219.953 203.192L161.037 169.285C158.772 167.981 155.8 167.328 152.827 167.328H152.81Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.04 189.051V160.893L188.337 165.636L161.603 150.26C156.915 147.563 149.307 147.563 144.618 150.26L140.461 152.905L82.4999 160.61V189.28H82.5176C82.5884 190.991 83.7384 192.701 86.0031 194.006L144.919 227.912C149.608 230.61 157.215 230.61 161.904 227.912L220.519 193.953C222.784 192.648 223.934 190.955 224.005 189.245H224.04V189.069V189.051Z",
    fill: "url(#paint0_linear_1_264)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.519 155.797L161.603 121.89C156.914 119.193 149.307 119.193 144.618 121.89L86.0027 155.85C81.3141 158.548 81.3141 162.92 86.0027 165.618L144.919 199.524C149.607 202.222 157.215 202.222 161.904 199.524L220.519 165.565C225.207 162.867 225.207 158.495 220.519 155.797Z",
    fill: "url(#paint1_radial_1_264)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.518 163.872L161.903 197.832C157.214 200.529 149.607 200.529 144.918 197.832L86.0019 163.925C84.038 162.797 82.9057 161.369 82.5872 159.888C82.1449 161.933 83.2772 164.066 86.0019 165.618L144.918 199.524C149.607 202.222 157.214 202.222 161.903 199.524L220.518 165.565C223.243 163.996 224.375 161.862 223.933 159.835C223.614 161.316 222.482 162.726 220.518 163.872Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.831 207.053L167.035 208.658V205.449L169.831 203.844V207.053Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.668 203.703L172.873 205.308V202.099L175.668 200.494V203.703Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.508 200.336L178.713 201.94V198.731L181.508 197.126V200.336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.731 209.592L173.935 211.197V207.988L176.731 206.383V209.592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.861 206.63L179.084 208.235V205.026L181.861 203.421V206.63Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.227 189.562L197.432 191.167V187.958L200.227 186.353V189.562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.291 180.323L213.514 181.928V178.719L216.291 177.114V180.323Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.328 196.985L184.551 198.59V195.381L187.328 193.776V196.985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M149.925 185.225L110.276 162.409C108.666 161.474 108.861 159.87 110.736 158.794L149.483 136.507C151.34 135.432 154.154 135.326 155.764 136.243L195.412 159.059C197.023 159.993 196.828 161.598 194.952 162.673L156.206 184.96C154.348 186.036 151.535 186.142 149.925 185.225Z",
    fill: "#06033E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.32 209.91L101.607 191.079C100.828 190.638 100.191 189.421 100.191 188.381V185.965C100.191 184.925 100.828 184.449 101.607 184.907L134.32 203.738C135.099 204.179 135.736 205.396 135.736 206.436V208.852C135.736 209.892 135.099 210.368 134.32 209.91Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.04 136.243V108.085L188.337 112.828L161.603 97.4524C156.915 94.7547 149.307 94.7547 144.618 97.4524L140.461 100.097L82.4999 107.802V136.472H82.5176C82.5884 138.182 83.7384 139.893 86.0031 141.198L144.919 175.104C149.608 177.802 157.215 177.802 161.904 175.104L220.519 141.145C222.784 139.84 223.934 138.147 224.005 136.437H224.04V136.261V136.243Z",
    fill: "url(#paint2_linear_1_264)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.519 102.989L161.603 69.0824C156.914 66.3847 149.307 66.3847 144.618 69.0824L86.0027 103.042C81.3141 105.739 81.3141 110.112 86.0027 112.81L144.919 146.716C149.607 149.414 157.215 149.414 161.904 146.716L220.519 112.757C225.207 110.059 225.207 105.687 220.519 102.989Z",
    fill: "url(#paint3_radial_1_264)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M192.459 105.034L158.117 85.2863C155.393 83.717 150.952 83.717 148.227 85.2863L114.081 105.069C111.356 106.639 111.356 109.195 114.081 110.765L148.422 130.513C151.147 132.082 155.587 132.082 158.312 130.513L192.459 110.729C195.183 109.16 195.183 106.603 192.459 105.034Z",
    fill: "#06033E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.518 111.047L161.903 145.006C157.214 147.704 149.607 147.704 144.918 145.006L86.0019 111.1C84.038 109.971 82.9057 108.543 82.5872 107.062C82.1449 109.107 83.2772 111.241 86.0019 112.792L144.918 146.699C149.607 149.396 157.214 149.396 161.903 146.699L220.518 112.739C223.243 111.17 224.375 109.037 223.933 107.009C223.614 108.49 222.482 109.918 220.518 111.047Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.831 154.228L167.035 155.832V152.623L169.831 151.019V154.228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.668 150.878L172.873 152.482V149.273L175.668 147.669V150.878Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.508 147.527L178.713 149.132V145.923L181.508 144.318V147.527Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.731 156.767L173.935 158.371V155.162L176.731 153.558V156.767Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.861 153.822L179.084 155.427V152.2L181.861 150.595V153.822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.227 136.754L197.432 138.359V135.15L200.227 133.545V136.754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.291 127.497L213.514 129.102V125.893L216.291 124.288V127.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.328 144.16L184.551 145.764V142.555L187.328 140.951V144.16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.04 83.4173V55.2589L188.337 60.0019L161.603 44.6268C156.915 41.9291 149.307 41.9291 144.618 44.6268L140.461 47.2716L82.4999 54.9768V83.6465H82.5176C82.5884 85.3568 83.7384 87.0671 86.0031 88.3719L144.919 122.278C149.608 124.976 157.215 124.976 161.904 122.278L220.519 88.319C222.784 87.0142 223.934 85.3216 224.005 83.6113H224.04V83.4349V83.4173Z",
    fill: "url(#paint4_linear_1_264)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.519 50.1632L161.603 16.2568C156.914 13.5591 149.307 13.5591 144.618 16.2568L86.0027 50.2161C81.3141 52.9138 81.3141 57.2866 86.0027 59.9843L144.919 93.8907C149.607 96.5884 157.215 96.5884 161.904 93.8907L220.519 59.9314C225.207 57.2337 225.207 52.8609 220.519 50.1632Z",
    fill: "url(#paint5_radial_1_264)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.519 50.1632L161.603 16.2568C156.914 13.5591 149.307 13.5591 144.618 16.2568L86.0027 50.2161C81.3141 52.9138 81.3141 57.2866 86.0027 59.9843L144.919 93.8907C149.607 96.5884 157.215 96.5884 161.904 93.8907L220.519 59.9314C225.207 57.2337 225.207 52.8609 220.519 50.1632Z",
    fill: "url(#paint6_radial_1_264)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.358 82.9236C151.199 82.9236 149.041 82.4475 147.342 81.4778L108.295 59.0145C106.543 58.0095 105.588 56.6166 105.588 55.1178C105.588 53.6191 106.543 52.2262 108.295 51.2212L147.13 28.7227C150.509 26.7831 155.782 26.7831 159.143 28.7227L198.191 51.1859C199.942 52.1909 200.897 53.5839 200.897 55.0826C200.897 56.5813 199.942 57.9742 198.191 58.9793L159.355 81.4778C157.675 82.4475 155.498 82.9236 153.34 82.9236H153.358ZM153.145 28.7755C151.252 28.7755 149.341 29.1987 147.908 30.0274L109.073 52.5259C107.817 53.2488 107.127 54.1657 107.127 55.1002C107.127 56.0347 107.817 56.9516 109.073 57.6745L148.121 80.1377C151.005 81.7952 155.711 81.7952 158.612 80.1377L197.447 57.6392C198.704 56.9163 199.394 55.9995 199.394 55.065C199.394 54.1305 198.704 53.2136 197.447 52.4907L158.4 30.0274C156.949 29.1987 155.056 28.7755 153.163 28.7755H153.145Z",
    fill: "#ED58B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.518 58.2211L161.903 92.1804C157.214 94.8781 149.607 94.8781 144.918 92.1804L86.0019 58.274C84.038 57.1455 82.9057 55.7173 82.5872 54.2362C82.1449 56.2816 83.2772 58.415 86.0019 59.9667L144.918 93.8731C149.607 96.5708 157.214 96.5708 161.903 93.8731L220.518 59.9138C223.243 58.3445 224.375 56.211 223.933 54.1833C223.614 55.6644 222.482 57.075 220.518 58.2211Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.831 101.42L167.035 103.024V99.8151L169.831 98.2106V101.42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.668 98.0519L172.873 99.6564V96.4474L175.668 94.8429V98.0519Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.508 94.7018L178.713 96.3064V93.0973L181.508 91.4928V94.7018Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.731 103.959L173.935 105.563V102.354L176.731 100.732V103.959Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.861 100.996L179.084 102.601V99.392L181.861 97.7874V100.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.227 83.9286L197.432 85.5332V82.3241L200.227 80.7196V83.9286Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.291 74.6718L213.514 76.294V73.0673L216.291 71.4628V74.6718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.328 91.3341L184.551 92.9562V89.7296L187.328 88.1251V91.3341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M163.496 161.774C159.639 161.88 155.746 161.915 151.819 161.88C121.104 161.633 92.6372 157.19 68.8761 149.731C45.1505 143.419 43.7174 168.157 51.9975 183.444C57.8891 194.323 65.8684 197.303 68.8761 198.431C92.6372 205.89 121.104 210.333 151.819 210.58C155.746 210.615 159.639 210.58 163.496 210.474C191.379 208.429 198.686 181.734 185.647 169.285C182.002 165.812 175.208 161.686 163.496 161.774Z",
    fill: "#172F78"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.867 131.429L307.442 130.583C307.053 129.807 306.593 128.696 306.045 127.198C300.861 112.122 285.716 98.4398 262.256 87.6314C245.943 78.3922 241.998 65.0447 241.042 59.7374C239.928 53.4781 241.184 44.5915 246.598 39.9014C250.561 36.4631 255.957 35.8107 262.627 37.9618C286.424 48.9113 301.763 62.7878 307.018 78.1453C308.132 82.4828 308.999 85.8682 308.999 101.173V127.145C308.999 129.419 308.999 129.56 308.345 130.618L307.849 131.429H307.867ZM242.069 59.5787C242.989 64.7449 246.828 77.7221 262.716 86.7145C286.406 97.6111 301.745 111.505 307.018 126.845C307.336 127.727 307.637 128.467 307.902 129.067C307.956 128.696 307.956 128.167 307.956 127.127V101.173C307.956 85.9916 307.089 82.6591 306.027 78.4451C300.861 63.4049 285.716 49.7401 262.256 38.9316C256.01 36.9215 250.95 37.5034 247.288 40.6948C242.192 45.1205 241.025 53.5838 242.086 59.5611L242.069 59.5787Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.04386 138.623L0 138.57V89.8706C0 89.4298 0 89.0067 0.0176925 88.5659C0.318466 80.4904 3.39697 72.6088 9.18242 65.0976L9.41243 64.8684C10.5271 63.7752 12.0486 62.2765 13.6232 62.0472C15.7287 61.7475 17.6041 62.8054 19.0372 65.0976C23.8495 72.7675 23.4072 94.7371 10.0494 114.397C2.22926 124.941 1.71618 130.971 1.06155 138.606L1.04386 138.623ZM14.2779 63.0523C14.1009 63.0523 13.924 63.0523 13.7471 63.0875C12.5086 63.2638 11.1463 64.6215 10.1378 65.6089L9.96089 65.7852C4.37005 73.0673 1.34463 80.7549 1.06155 88.6011C1.06155 89.0243 1.04386 89.4475 1.04386 89.8706V130.371C2.05233 125.646 4.10467 120.656 9.18242 113.815C22.2926 94.5255 22.8057 73.1025 18.1348 65.6794C17.3741 64.4628 16.1002 63.0699 14.2779 63.0699V63.0523Z",
    fill: "#03A7D3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.1725 163.961C10.8809 163.961 9.20012 163.273 7.3424 160.752C0.990782 152.094 0.371543 143.648 0 138.606V89.8706H1.04386C1.04386 97.2232 3.45004 104.488 8.19164 111.452C18.6125 128.626 19.851 145.588 18.931 152.905C18.1879 158.9 15.941 163.097 13.0748 163.837C12.7917 163.908 12.4909 163.961 12.1548 163.961H12.1725ZM1.04386 98.3693V138.57C1.39771 143.472 1.99926 151.724 8.19164 160.134C9.28858 161.633 10.9871 163.291 12.8271 162.832C15.2333 162.215 17.2148 158.265 17.9048 152.782C18.8072 145.606 17.5864 128.926 7.32471 112.017C4.29928 107.573 2.21157 103.007 1.06155 98.3693H1.04386Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.527 211.109C153.625 211.109 152.722 211.109 151.82 211.109C122.061 210.862 93.3284 206.665 68.7181 198.943C65.6396 197.796 57.5188 194.764 51.5387 183.708C46.5848 174.575 44.5855 160.787 50.5833 153.205C53.2195 149.873 58.5803 146.47 69.0189 149.255C93.5584 156.943 122.185 161.139 151.838 161.386C155.712 161.422 159.64 161.386 163.497 161.28C163.639 161.28 163.762 161.28 163.904 161.28C175.563 161.28 182.357 165.424 186.02 168.933C192.106 174.751 194.052 184.026 190.991 192.56C187.17 203.139 176.908 210.051 163.55 211.021C160.56 211.109 157.535 211.144 154.545 211.144L154.527 211.109ZM61.9065 149.255C57.3949 149.255 53.821 150.789 51.4148 153.84C45.6825 161.069 47.6817 174.381 52.4587 183.215C58.2618 193.935 66.1173 196.862 69.072 197.955C93.5584 205.643 122.185 209.822 151.838 210.068C155.73 210.104 159.64 210.068 163.497 209.963C176.413 209.01 186.32 202.363 190 192.189C192.937 184.061 191.097 175.21 185.294 169.673C181.738 166.27 175.05 162.215 163.515 162.321C159.64 162.427 155.712 162.462 151.82 162.427C122.061 162.18 93.3284 157.983 68.7181 150.26C66.2589 149.608 63.9765 149.273 61.9065 149.273V149.255Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.587 193.3C246.828 193.3 242.882 191.572 240.122 188.205C234.779 181.716 234.655 169.92 239.822 160.17C245.642 149.185 254.683 144.389 258.08 142.591C282.425 132.188 298.649 118.77 305.018 103.8C305.726 102.301 306.345 101.173 306.859 100.415L306.982 100.221L308.168 100.062L308.309 100.468C308.734 101.649 308.911 102.143 308.964 107.979V122.966C308.822 144.107 307.584 147.968 305.992 152.87C299.498 168.139 283.097 181.751 258.523 192.242C256.063 192.965 253.728 193.318 251.569 193.318L251.587 193.3ZM307.513 101.314C307.071 102.019 306.558 102.989 305.974 104.206C299.498 119.422 283.097 133.016 258.523 143.525C255.232 145.271 246.403 149.961 240.724 160.663C235.752 170.061 235.823 181.363 240.901 187.552C243.555 190.779 248.703 194.023 258.151 191.255C282.407 180.887 298.631 167.469 305.001 152.5C306.54 147.739 307.779 143.931 307.902 122.966V107.979C307.867 103.271 307.743 102.178 307.495 101.331L307.513 101.314Z",
    fill: "#03A7D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_264",
    x1: 73.9721,
    y1: 189.086,
    x2: 173.793,
    y2: 189.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#04B0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0E6BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#143F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_264",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.2792 114.503) scale(222.908 222.146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#03BAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0895C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#105A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_264",
    x1: -0.000319921,
    y1: 136.261,
    x2: 1.76893,
    y2: 136.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#04B0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0E6BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#143F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1_264",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.883904 61.677) scale(222.908 222.146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#03BAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0895C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#105A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_264",
    x1: -0.000319921,
    y1: 83.4526,
    x2: 1.76893,
    y2: 83.4526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#04B0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0E6BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#143F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1_264",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.883904 8.85131) scale(222.908 222.146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#03BAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0895C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#105A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1_264",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.9524 22.2325) scale(153.26 152.706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#793CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B23C2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 309,
    height: 249,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrediblyFlexibleImg);
export default __webpack_public_path__ + "static/media/IncrediblyFlexibleImg.1bf0dee2e66555b76d413604ee191670.svg";
export { ForwardRef as ReactComponent };